import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { decryptString } from '../funciones/funciones';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard  {

  rol: any

  // Mapa de permisos por path
  private permisosPorRol: { [rol: string]: string[] } = {
    admin: ['*'], // acceso total
    legal: [
      '/dashboard/reportes-home/requerimientos-bcra',
      '/dashboard/reportes-home/reportes-usuarios-home'
    ],
    admin_viewer: [
      '/dashboard/reportes-home',
      '/dashboard/sistema/versiones',
      '/dashboard/sistema/configuraciones-sistema',
    ]
  };

  constructor (
    private router: Router,
    private loginService: LoginService,
    private toastService: ToastService) {
      this.rol = decryptString(this.loginService.isAdmin)
    }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const userRole = this.rol
      const currentPath = state.url;

      if (!userRole) {
        this.router.navigate(['dashboard/login']);
        return false;
      }

      const pathsPermitidos = this.permisosPorRol[userRole] || [];

      const tienePermiso =
        pathsPermitidos.includes('*') ||
        pathsPermitidos.some(path => currentPath.startsWith(path));

      if (!tienePermiso) {
        this.toastService.show('Acceso denegado: No tienes permiso para ver esta sección.', 'danger');
        this.router.navigate(['dashboard/home-dash']);
      }

      return tienePermiso;
    // if (this.rol != 'admin') {
    //   this.toastService.show('Acceso denegado: No tienes permiso para ver esta sección.', 'danger');
    //   this.router.navigate(['dashboard/home-dash']);
    //   return false;
    // }
    // return true;
  }


}
